import { motion } from "framer-motion";

const STATS = [
    { value: "15,000 PSI", label: "API 6A Pressure Class" },
    { value: "2\" – 48\"", label: "Bore Range, API 6D" },
    { value: "150 – 2500", label: "ASME Pressure Classes" },
    { value: "-196°C", label: "Cryogenic Capability" },
];

export default function Stats() {
    return (
        <section
            data-testid="stats-section"
            className="border-y border-white/10 bg-obsidian-800"
        >
            <div className="mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-4">
                {STATS.map((s, i) => (
                    <motion.div
                        key={s.label}
                        data-testid={`stat-metric-${i}`}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.4 }}
                        transition={{ duration: 0.6, delay: i * 0.1 }}
                        className={`px-6 py-10 sm:px-8 ${i % 2 === 1 ? "border-l border-white/10" : ""} ${i > 1 ? "border-t border-white/10 lg:border-t-0" : ""} ${i > 0 ? "lg:border-l lg:border-white/10" : ""}`}
                    >
                        <p className="font-display text-4xl font-black uppercase tracking-tight text-tactical sm:text-5xl">
                            {s.value}
                        </p>
                        <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.22em] text-slate-400">
                            {s.label}
                        </p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
